import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import styles from "./MainCarousel.module.scss";


interface PropsType {
    deadLineDate : string,
    isWebStatus : boolean
}

export default function  Clock ( props: PropsType ) {
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const leading0 = (num : any) => {
    return num < 10 ? "0" + num : num;
  };

  const getTimeUntil = (deadline : any) => {
    const time = Date.parse(deadline) - Date.parse(new Date().toString());
    if (time < 0) {
      setDays(0);
      setHours(0);
      setMinutes(0);
      setSeconds(0);
    } else {
      setDays(Math.floor(time / (1000 * 60 * 60 * 24)));
      setHours(Math.floor((time / (1000 * 60 * 60)) % 24));
      setMinutes(Math.floor((time / 1000 / 60) % 60));
      setSeconds(Math.floor((time / 1000) % 60));
    }
  };

  useEffect(() => {
    setInterval(() => getTimeUntil(props.deadLineDate), 1000);

    // return () => getTimeUntil(props.deadLineDate);
  }, [props.deadLineDate]);

  return (
    <div>
        {
            props.isWebStatus ?
            <>
                <Row className={`${styles.TimerDiv}`}>
                    <Col md="3" lg="3">
                        <Row className={`${styles.countDownTimer_font}`}>
                            {leading0(days)}
                        </Row>
                        <Row className={`${styles.TimeText}`}>
                            DAYS
                        </Row>
                    </Col>
                    <Col md="3" lg="3">
                        <Row className={`${styles.countDownTimer_font}`}>
                            {leading0(hours)} :
                        </Row>
                        <Row className={`${styles.TimeText}`}>
                            HRS
                        </Row>
                    </Col>
                    <Col md="3" lg="3">
                        <Row className={`${styles.countDownTimer_font}`}>
                            {leading0(minutes)} :
                        </Row>
                        <Row className={`${styles.TimeText}`}>
                            MINS
                        </Row>
                    </Col>
                    <Col md="3" lg="3">
                        <Row className={`${styles.countDownTimer_font}`}>
                            {leading0(seconds)} 
                        </Row>
                        <Row className={`${styles.TimeText}`}>
                            SECS
                        </Row>
                    </Col>
                </Row>
            </>
            :
            <>
                <Row className={`${styles.TimerDiv}`}>
                    <Col xs="3" sm="3">
                        <Row className={`${styles.countDownTimer_font_mobile}`}>
                            {leading0(days)}
                        </Row>
                        <Row className={`${styles.TimeText_mobile}`}>
                            DAYS
                        </Row>
                    </Col>
                    <Col xs="3" sm="3">
                        <Row className={`${styles.countDownTimer_font_mobile}`}>
                            {leading0(hours)} :
                        </Row>
                        <Row className={`${styles.TimeText_mobile}`}>
                            HRS
                        </Row>
                    </Col>
                    <Col xs="3" sm="3">
                        <Row className={`${styles.countDownTimer_font_mobile}`}>
                            {leading0(minutes)} :
                        </Row>
                        <Row className={`${styles.TimeText_mobile}`}>
                            MIN
                        </Row>
                    </Col>
                    <Col xs="3" sm="3">
                        <Row className={`${styles.countDownTimer_font_mobile}`}>
                            {leading0(seconds)} 
                        </Row>
                        <Row className={`${styles.TimeText_mobile}`}>
                            SECS
                        </Row>
                    </Col>
                </Row>
            </>
        }
    </div>
  );
};

